export default __webpack_public_path__ + "static/media/jonathon.af057b26.png";